<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-tipopedido') {
            next({ name: 'ven-tipopedido-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-tipopedido') {
            this.$router.push({ name: 'ven-tipopedido-list' });
        }
    },
};
</script>
